import { render, staticRenderFns } from "./RecurrentPay.vue?vue&type=template&id=2d0a0533&scoped=true"
import script from "./RecurrentPay.vue?vue&type=script&lang=js"
export * from "./RecurrentPay.vue?vue&type=script&lang=js"
import style0 from "./RecurrentPay.vue?vue&type=style&index=0&id=2d0a0533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a0533",
  null
  
)

export default component.exports